export const wfTypeMap = new Map([
  ['1', '渠道遴选'],
  ['2', '新增商户/门店'],
  ['3', '修改商户/门店'],
  ['4', '退出商户/门店']
])

export const wfTypeColorMap = {
  '1': '#409EFF',
  '2': '#67C23A',
  '3': '#E6A23C',
  '4': '#F56C6C'
}

export const wfStateMap = new Map([
  ['0', '暂存'],
  ['1', '待初审'],
  ['1-0', '文件解析中'],
  ['1-1', '文件解析完毕'],
  ['1-2', '文件识别处理完毕'],
  ['2', '初审部分通过,部份终审中'],
  ['3', '初审通过,终审中'],
  ['4', '初审不通过'],
  ['5', '终审部分通过'],
  ['6', '终审通过'],
  ['7', '终审不通过']
])

export const wfStateColorMap = {
  '0': '#909399',
  '1': '#E6A23C',
  '1-0': '#409EFF',
  '1-1': '#409EFF',
  '1-2': '#409EFF',
  '2': '#E6A23C',
  '3': '#E6A23C',
  '4': '#F56C6C',
  '5': '#E6A23C',
  '6': '#67C23A',
  '7': '#F56C6C'
}

export const wfStateList = [
  // { value: '0', label: '暂存' },
  // { value: '1', label: '待初审' },
  // { value: '1-0', label: '文件解析中' },
  // { value: '1-1', label: '文件解析完毕' },
  // { value: '1-2', label: '文件识别处理完毕' },
  // { value: '2', label: '初审部分通过,部份终审中' },
  // { value: '3', label: '初审通过,终审中' },
  // { value: '4', label: '初审不通过' },
  // { value: '5', label: '终审部分通过' },
  // { value: '6', label: '终审通过' },
  // { value: '7', label: '终审不通过' }
  { value: '0', label: '待提交' },
  { value: '1', label: '待审核' },
  { value: '2', label: '审核中' },
  { value: '3', label: '审核完成' }
]

export const operatorTypeMap = new Map([
  ['0', '商户及门店'],
  ['1', '门店']
])

export const mockWorkflows = [
  {
    id: 'WF001',
    channelId: 'CH001',
    channelName: '北京京东世纪贸易有限公司',
    wfType: '1',
    wfState: '7',
    firstAuditUser: '审核员A',
    firstAuditTime: '2025-06-20 09:00',
    firstAuditDesc: '材料齐全，初审通过。',
    secondAuditUser: '审核员B',
    secondAuditTime: '2025-07-01 14:00',
    secondAuditDesc: '部分商户资质材料不符合要求，终审不通过。',
    auditDesc: '渠道遴选终审不通过，部分商户资质材料不符合要求，请补充后重新提交。',
    createrId: '张三',
    createTime: '2025-06-15 10:30',
    updaterId: '审核员B',
    updateTime: '2025-07-01 14:00',
    fileId: 'FILE001',
    fileIdBackup: '',
    parentId: '',
    merchantNum: 156,
    storeNum: 1280,
    filesDir: '/nas-data/screening/审核库/张三/渠道上报材料/',
    operatorType: '0',
    remark: '',
    checkFlag: '0'
  },
  {
    id: 'WF015',
    channelId: 'CH001',
    channelName: '北京京东世纪贸易有限公司',
    wfType: '1',
    wfState: '6',
    firstAuditUser: '审核员A',
    firstAuditTime: '2025-08-01 10:00',
    firstAuditDesc: '补充材料齐全，初审通过。',
    secondAuditUser: '审核员B',
    secondAuditTime: '2025-08-05 15:00',
    secondAuditDesc: '补充材料齐全，资质符合要求，终审通过。',
    auditDesc: '驳回重提后补充完整，初审通过，终审通过，共计商户156家，门店1280家，全部符合条件。',
    createrId: '张三',
    createTime: '2025-07-28 09:00',
    updaterId: '审核员B',
    updateTime: '2025-08-05 15:00',
    fileId: 'FILE015',
    fileIdBackup: '',
    parentId: 'WF001',
    merchantNum: 156,
    storeNum: 1280,
    filesDir: '/nas-data/screening/审核库/张三/渠道上报材料/',
    operatorType: '0',
    remark: '驳回重提',
    checkFlag: '0'
  },
  {
    id: 'WF002',
    channelId: 'CH002',
    channelName: '上海寻梦信息技术有限公司',
    wfType: '1',
    wfState: '3',
    firstAuditUser: '审核员A',
    firstAuditTime: '2025-06-25 11:00',
    firstAuditDesc: '材料齐全，初审通过。',
    secondAuditUser: '',
    secondAuditTime: '',
    secondAuditDesc: '',
    auditDesc: '',
    createrId: '李四',
    createTime: '2025-06-20 09:15',
    updaterId: '审核员A',
    updateTime: '2025-06-25 11:00',
    fileId: 'FILE002',
    fileIdBackup: '',
    parentId: '',
    merchantNum: 98,
    storeNum: 760,
    filesDir: '/nas-data/screening/审核库/李四/渠道上报材料/',
    operatorType: '0',
    remark: '',
    checkFlag: '0'
  },
  {
    id: 'WF003',
    channelId: 'CH003',
    channelName: '深圳美团科技有限公司',
    wfType: '2',
    wfState: '1',
    firstAuditUser: '',
    firstAuditTime: '',
    firstAuditDesc: '',
    secondAuditUser: '',
    secondAuditTime: '',
    secondAuditDesc: '',
    auditDesc: '',
    createrId: '王五',
    createTime: '2025-07-01 14:00',
    updaterId: '王五',
    updateTime: '2025-07-01 14:00',
    fileId: 'FILE003',
    fileIdBackup: '',
    parentId: '',
    merchantNum: 45,
    storeNum: 320,
    filesDir: '/nas-data/screening/审核库/王五/新增商户材料/',
    operatorType: '0',
    remark: '新增商户批量申报',
    checkFlag: '0'
  },
  {
    id: 'WF004',
    channelId: 'CH001',
    channelName: '北京京东世纪贸易有限公司',
    wfType: '2',
    wfState: '6',
    firstAuditUser: '审核员A',
    firstAuditTime: '2025-06-22 10:00',
    firstAuditDesc: '商户资料完整，初审通过。',
    secondAuditUser: '审核员B',
    secondAuditTime: '2025-06-28 15:00',
    secondAuditDesc: '终审通过。',
    auditDesc: '本次新增商户5家，门店67家，全部审核通过。',
    createrId: '张三',
    createTime: '2025-06-20 10:00',
    updaterId: '审核员B',
    updateTime: '2025-06-28 15:00',
    fileId: 'FILE004',
    fileIdBackup: '',
    parentId: '',
    merchantNum: 5,
    storeNum: 67,
    filesDir: '/nas-data/screening/审核库/张三/新增商户材料/',
    operatorType: '0',
    remark: '',
    checkFlag: '0'
  },
  {
    id: 'WF005',
    channelId: 'CH004',
    channelName: '广州唯品会信息科技有限公司',
    wfType: '1',
    wfState: '7',
    firstAuditUser: '审核员A',
    firstAuditTime: '2025-07-08 10:00',
    firstAuditDesc: '材料不完整，缺少业务联系人身份证明文件。',
    secondAuditUser: '',
    secondAuditTime: '',
    secondAuditDesc: '',
    auditDesc: '部分商户资质材料不符合要求，请补充后重新提交。',
    createrId: '赵六',
    createTime: '2025-07-05 16:30',
    updaterId: '审核员A',
    updateTime: '2025-07-08 10:00',
    fileId: 'FILE005',
    fileIdBackup: '',
    parentId: '',
    merchantNum: 67,
    storeNum: 0,
    filesDir: '/nas-data/screening/审核库/赵六/渠道上报材料/',
    operatorType: '0',
    remark: '',
    checkFlag: '1'
  },
  {
    id: 'WF011',
    channelId: 'CH004',
    channelName: '广州唯品会信息科技有限公司',
    wfType: '1',
    wfState: '3',
    firstAuditUser: '审核员A',
    firstAuditTime: '2025-07-20 10:00',
    firstAuditDesc: '补充材料已齐全，初审通过。',
    secondAuditUser: '',
    secondAuditTime: '',
    secondAuditDesc: '',
    auditDesc: '驳回重提后补充材料，初审通过，待终审。',
    createrId: '赵六',
    createTime: '2025-07-12 09:00',
    updaterId: '审核员A',
    updateTime: '2025-07-20 10:00',
    fileId: 'FILE011',
    fileIdBackup: '',
    parentId: 'WF005',
    merchantNum: 67,
    storeNum: 0,
    filesDir: '/nas-data/screening/审核库/赵六/渠道上报材料/',
    operatorType: '0',
    remark: '驳回重提补充材料',
    checkFlag: '0'
  },
  {
    id: 'WF006',
    channelId: 'CH005',
    channelName: '杭州网易严选贸易有限公司',
    wfType: '1',
    wfState: '7',
    firstAuditUser: '审核员A',
    firstAuditTime: '2025-07-12 09:00',
    firstAuditDesc: '初审通过，材料完整。',
    secondAuditUser: '审核员B',
    secondAuditTime: '2025-07-15 16:00',
    secondAuditDesc: '企业销售额证明材料不符合要求，终审不通过。',
    auditDesc: '渠道遴选终审不通过，销售额证明材料不符合要求。',
    createrId: '孙七',
    createTime: '2025-07-10 10:00',
    updaterId: '审核员B',
    updateTime: '2025-07-15 16:00',
    fileId: 'FILE006',
    fileIdBackup: '',
    parentId: '',
    merchantNum: 52,
    storeNum: 0,
    filesDir: '/nas-data/screening/审核库/孙七/渠道上报材料/',
    operatorType: '0',
    remark: '',
    checkFlag: '1'
  },
  {
    id: 'WF007',
    channelId: 'CH006',
    channelName: '四川海底捞餐饮股份有限公司',
    wfType: '2',
    wfState: '1-1',
    firstAuditUser: '',
    firstAuditTime: '',
    firstAuditDesc: '',
    secondAuditUser: '',
    secondAuditTime: '',
    secondAuditDesc: '',
    auditDesc: '',
    createrId: '周八',
    createTime: '2025-07-15 08:30',
    updaterId: '系统',
    updateTime: '2025-07-16 09:00',
    fileId: 'FILE007',
    fileIdBackup: '',
    parentId: '',
    merchantNum: 35,
    storeNum: 280,
    filesDir: '/nas-data/screening/审核库/周八/新增商户材料/',
    operatorType: '0',
    remark: '',
    checkFlag: '0'
  },
  {
    id: 'WF008',
    channelId: 'CH001',
    channelName: '北京京东世纪贸易有限公司',
    wfType: '4',
    wfState: '1',
    firstAuditUser: '',
    firstAuditTime: '',
    firstAuditDesc: '',
    secondAuditUser: '',
    secondAuditTime: '',
    secondAuditDesc: '',
    auditDesc: '',
    createrId: '张三',
    createTime: '2025-07-20 11:00',
    updaterId: '张三',
    updateTime: '2025-07-20 11:00',
    fileId: 'FILE008',
    fileIdBackup: '',
    parentId: '',
    merchantNum: 3,
    storeNum: 12,
    filesDir: '/nas-data/screening/审核库/张三/退出商户材料/',
    operatorType: '0',
    remark: '退出3家商户12家门店',
    checkFlag: '0'
  },
  {
    id: 'WF009',
    channelId: 'CH002',
    channelName: '上海寻梦信息技术有限公司',
    wfType: '3',
    wfState: '0',
    firstAuditUser: '',
    firstAuditTime: '',
    firstAuditDesc: '',
    secondAuditUser: '',
    secondAuditTime: '',
    secondAuditDesc: '',
    auditDesc: '',
    createrId: '李四',
    createTime: '2025-07-22 14:30',
    updaterId: '李四',
    updateTime: '2025-07-22 14:30',
    fileId: 'FILE009',
    fileIdBackup: '',
    parentId: '',
    merchantNum: 2,
    storeNum: 5,
    filesDir: '/nas-data/screening/审核库/李四/修改商户材料/',
    operatorType: '1',
    remark: '仅修改门店信息',
    checkFlag: '0'
  },
  {
    id: 'WF012',
    channelId: 'CH002',
    channelName: '上海寻梦信息技术有限公司',
    wfType: '1',
    wfState: '7',
    firstAuditUser: '审核员A',
    firstAuditTime: '2025-07-05 10:00',
    firstAuditDesc: '企业资质证明材料不符合要求。',
    secondAuditUser: '',
    secondAuditTime: '',
    secondAuditDesc: '',
    auditDesc: '终审不通过，资质材料不合格。',
    createrId: '李四',
    createTime: '2025-07-01 09:00',
    updaterId: '审核员B',
    updateTime: '2025-07-05 10:00',
    fileId: 'FILE012',
    fileIdBackup: '',
    parentId: '',
    merchantNum: 98,
    storeNum: 760,
    filesDir: '/nas-data/screening/审核库/李四/渠道上报材料/',
    operatorType: '0',
    remark: '',
    checkFlag: '1'
  },
  {
    id: 'WF013',
    channelId: 'CH002',
    channelName: '上海寻梦信息技术有限公司',
    wfType: '1',
    wfState: '6',
    firstAuditUser: '审核员A',
    firstAuditTime: '2025-07-15 10:00',
    firstAuditDesc: '补充资质齐全，初审通过。',
    secondAuditUser: '审核员B',
    secondAuditTime: '2025-07-25 14:00',
    secondAuditDesc: '终审通过，资质符合要求。',
    auditDesc: '驳回重提后资质齐全，终审通过。',
    createrId: '李四',
    createTime: '2025-07-10 09:00',
    updaterId: '审核员B',
    updateTime: '2025-07-25 14:00',
    fileId: 'FILE013',
    fileIdBackup: '',
    parentId: 'WF012',
    merchantNum: 98,
    storeNum: 760,
    filesDir: '/nas-data/screening/审核库/李四/渠道上报材料/',
    operatorType: '0',
    remark: '驳回重提补充资质',
    checkFlag: '0'
  },
  {
    id: 'WF014',
    channelId: 'CH002',
    channelName: '上海寻梦信息技术有限公司',
    wfType: '1',
    wfState: '1',
    firstAuditUser: '',
    firstAuditTime: '',
    firstAuditDesc: '',
    secondAuditUser: '',
    secondAuditTime: '',
    secondAuditDesc: '',
    auditDesc: '',
    createrId: '李四',
    createTime: '2025-07-28 10:00',
    updaterId: '李四',
    updateTime: '2025-07-28 10:00',
    fileId: 'FILE014',
    fileIdBackup: '',
    parentId: '',
    merchantNum: 50,
    storeNum: 300,
    filesDir: '/nas-data/screening/审核库/李四/渠道上报材料/',
    operatorType: '0',
    remark: '第二批渠道申请',
    checkFlag: '0'
  }
]

export function getChannelById(channelId) {
  return mockWorkflows.find(w => w.channelId === channelId)
}

export const mockMerchantsByWorkflow = {
  'WF001': [
    { merchantId: 'M001', channelId: 'CH001', merchantName: '北京京东家电专卖店', merchantCode: 'JM-2025-001', contact: '王五', phone: '13900139011', storeNum: 156, createTime: '2025-06-20 10:00', address: '北京市朝阳区建国路88号', status: '1', flowId: 'WF001' },
    { merchantId: 'M002', channelId: 'CH001', merchantName: '京东数码旗舰店', merchantCode: 'JM-2025-002', contact: '赵六', phone: '13900139012', storeNum: 89, createTime: '2025-06-22 14:30', address: '北京市海淀区中关村大街1号', status: '1', flowId: 'WF001' },
    { merchantId: 'M003', channelId: 'CH001', merchantName: '京东超市连锁店', merchantCode: 'JM-2025-003', contact: '钱七', phone: '13900139013', storeNum: 234, createTime: '2025-06-25 09:00', address: '北京市丰台区南三环西路16号', status: '1', flowId: 'WF001' },
  ],
  'WF015': [
    { merchantId: 'M018', channelId: 'CH001', merchantName: '京东家电朝阳店（驳回重提）', merchantCode: 'JM-2025-001', contact: '王五', phone: '13900139011', storeNum: 156, createTime: '2025-07-28 09:00', address: '北京市朝阳区建国路88号', status: '1', flowId: 'WF015' },
    { merchantId: 'M019', channelId: 'CH001', merchantName: '京东数码旗舰店（驳回重提）', merchantCode: 'JM-2025-002', contact: '赵六', phone: '13900139012', storeNum: 89, createTime: '2025-07-28 09:00', address: '北京市海淀区中关村大街1号', status: '1', flowId: 'WF015' },
    { merchantId: 'M020', channelId: 'CH001', merchantName: '京东超市连锁店（驳回重提）', merchantCode: 'JM-2025-003', contact: '钱七', phone: '13900139013', storeNum: 234, createTime: '2025-07-28 09:00', address: '北京市丰台区南三环西路16号', status: '1', flowId: 'WF015' },
  ],
  'WF002': [
    { merchantId: 'M006', channelId: 'CH002', merchantName: '拼多多上海旗舰店', merchantCode: 'PM-2025-001', contact: '周一', phone: '13900139021', storeNum: 45, createTime: '2025-06-25 10:30', address: '上海市浦东新区张江高科技园区', status: '1', flowId: 'WF002' },
    { merchantId: 'M007', channelId: 'CH002', merchantName: '拼多多农产品直营店', merchantCode: 'PM-2025-002', contact: '吴二', phone: '13900139022', storeNum: 32, createTime: '2025-06-28 15:00', address: '上海市闵行区七宝镇', status: '1', flowId: 'WF002' },
  ],
  'WF003': [
    { merchantId: 'M008', channelId: 'CH003', merchantName: '美团龙华民治店', merchantCode: 'MT-2025-001', contact: '郑三', phone: '13900139031', storeNum: 12, createTime: '2025-07-05 09:00', address: '深圳市龙华区民治大道', status: '1', flowId: 'WF003' },
    { merchantId: 'M009', channelId: 'CH003', merchantName: '美团南山科技园店', merchantCode: 'MT-2025-002', contact: '陈四', phone: '13900139032', storeNum: 8, createTime: '2025-07-08 14:00', address: '深圳市南山区科技园南区', status: '1', flowId: 'WF003' },
  ],
  'WF004': [
    { merchantId: 'M004', channelId: 'CH001', merchantName: '京东母婴生活馆', merchantCode: 'JM-2025-004', contact: '孙八', phone: '13900139014', storeNum: 45, createTime: '2025-06-28 11:00', address: '北京市通州区新华大街100号', status: '1', flowId: 'WF004' },
    { merchantId: 'M005', channelId: 'CH001', merchantName: '京东家居体验店', merchantCode: 'JM-2025-005', contact: '李九', phone: '13900139015', storeNum: 67, createTime: '2025-07-01 16:00', address: '北京市大兴区黄村东大街38号', status: '1', flowId: 'WF004' },
  ],
  'WF005': [
    { merchantId: 'M010', channelId: 'CH004', merchantName: '唯品会广州旗舰店', merchantCode: 'VP-2025-001', contact: '刘十', phone: '13900139041', storeNum: 67, createTime: '2025-07-05 16:30', address: '广州市荔湾区芳村大道南1号', status: '1', flowId: 'WF005' },
  ],
  'WF006': [
    { merchantId: 'M011', channelId: 'CH005', merchantName: '网易严选杭州旗舰店', merchantCode: 'YY-2025-001', contact: '陈十一', phone: '13900139051', storeNum: 52, createTime: '2025-07-10 10:00', address: '杭州市滨江区网商路599号', status: '1', flowId: 'WF006' },
  ],
  'WF007': [
    { merchantId: 'M012', channelId: 'CH006', merchantName: '海底捞成都旗舰店', merchantCode: 'HDL-2025-001', contact: '刘五', phone: '13900139061', storeNum: 5, createTime: '2025-07-18 10:30', address: '成都市锦江区春熙路', status: '1', flowId: 'WF007' },
  ],
  'WF008': [
    { merchantId: 'M013', channelId: 'CH001', merchantName: '京东退出商户A', merchantCode: 'JM-EXIT-001', contact: '测试', phone: '13800138001', storeNum: 1, createTime: '2025-07-20 11:00', address: '北京市测试地址', status: '0', flowId: 'WF008' },
  ],
  'WF009': [],
  'WF010': [
    { merchantId: 'M014', channelId: 'CH003', merchantName: '美团新增门店商户', merchantCode: 'MT-NEW-001', contact: '测试', phone: '13800138002', storeNum: 10, createTime: '2025-07-18 09:00', address: '深圳市南山区', status: '1', flowId: 'WF010' },
  ],
  'WF011': [
    { merchantId: 'M015', channelId: 'CH004', merchantName: '唯品会广州旗舰店', merchantCode: 'VP-2025-002', contact: '刘十', phone: '13900139042', storeNum: 67, createTime: '2025-07-12 09:00', address: '广州市荔湾区芳村大道南1号', status: '1', flowId: 'WF011' },
  ],
  'WF013': [
    { merchantId: 'M016', channelId: 'CH002', merchantName: '拼多多上海旗舰店', merchantCode: 'PM-2025-002', contact: '周一', phone: '13900139023', storeNum: 98, createTime: '2025-07-10 09:00', address: '上海市浦东新区张江高科技园区', status: '1', flowId: 'WF013' },
  ],
  'WF014': [
    { merchantId: 'M017', channelId: 'CH002', merchantName: '拼多多第二批商户', merchantCode: 'PM-2025-003', contact: '吴二', phone: '13900139024', storeNum: 50, createTime: '2025-07-28 10:00', address: '上海市闵行区七宝镇', status: '1', flowId: 'WF014' },
  ],
}

export const mockStoresByWorkflow = {
  'WF001': [
    { storeId: 'S001', merchantId: 'M001', channelId: 'CH001', storeName: '京东家电朝阳一店', storeCode: 'JS-2025-001', address: '北京市朝阳区望京SOHO T1', status: '1', contact: '张店长', phone: '18800110001', area: 320, createTime: '2025-06-25', flowId: 'WF001' },
    { storeId: 'S002', merchantId: 'M001', channelId: 'CH001', storeName: '京东家电朝阳二店', storeCode: 'JS-2025-002', address: '北京市朝阳区三里屯太古里', status: '1', contact: '李店长', phone: '18800110002', area: 280, createTime: '2025-06-26', flowId: 'WF001' },
    { storeId: 'S003', merchantId: 'M001', channelId: 'CH001', storeName: '京东家电海淀店', storeCode: 'JS-2025-003', address: '北京市海淀区五道口', status: '1', contact: '王店长', phone: '18800110003', area: 350, createTime: '2025-06-28', flowId: 'WF001' },
    { storeId: 'S005', merchantId: 'M002', channelId: 'CH001', storeName: '京东数码中关村店', storeCode: 'JS-2025-005', address: '北京市海淀区中关村大街1号', status: '1', contact: '刘店长', phone: '18800110005', area: 180, createTime: '2025-06-22', flowId: 'WF001' },
    { storeId: 'S006', merchantId: 'M002', channelId: 'CH001', storeName: '京东数码西单店', storeCode: 'JS-2025-006', address: '北京市西城区西单北大街', status: '1', contact: '陈店长', phone: '18800110006', area: 150, createTime: '2025-06-24', flowId: 'WF001' },
    { storeId: 'S007', merchantId: 'M003', channelId: 'CH001', storeName: '京东超市丰台一店', storeCode: 'JS-2025-007', address: '北京市丰台区南三环西路16号', status: '1', contact: '杨店长', phone: '18800110007', area: 500, createTime: '2025-06-25', flowId: 'WF001' },
  ],
  'WF015': [
    { storeId: 'S020', merchantId: 'M018', channelId: 'CH001', storeName: '京东家电朝阳一店（驳回重提）', storeCode: 'JS-2025-001', address: '北京市朝阳区望京SOHO T1', status: '1', contact: '张店长', phone: '18800110001', area: 320, createTime: '2025-07-28', flowId: 'WF015' },
    { storeId: 'S021', merchantId: 'M018', channelId: 'CH001', storeName: '京东家电朝阳二店（驳回重提）', storeCode: 'JS-2025-002', address: '北京市朝阳区三里屯太古里', status: '1', contact: '李店长', phone: '18800110002', area: 280, createTime: '2025-07-28', flowId: 'WF015' },
    { storeId: 'S022', merchantId: 'M018', channelId: 'CH001', storeName: '京东家电海淀店（驳回重提）', storeCode: 'JS-2025-003', address: '北京市海淀区五道口', status: '1', contact: '王店长', phone: '18800110003', area: 350, createTime: '2025-07-28', flowId: 'WF015' },
    { storeId: 'S023', merchantId: 'M019', channelId: 'CH001', storeName: '京东数码中关村店（驳回重提）', storeCode: 'JS-2025-005', address: '北京市海淀区中关村大街1号', status: '1', contact: '刘店长', phone: '18800110005', area: 180, createTime: '2025-07-28', flowId: 'WF015' },
    { storeId: 'S024', merchantId: 'M020', channelId: 'CH001', storeName: '京东超市丰台一店（驳回重提）', storeCode: 'JS-2025-007', address: '北京市丰台区南三环西路16号', status: '1', contact: '杨店长', phone: '18800110007', area: 500, createTime: '2025-07-28', flowId: 'WF015' },
  ],
  'WF002': [
    { storeId: 'S010', merchantId: 'M006', channelId: 'CH002', storeName: '拼多多上海旗舰店', storeCode: 'PM-2025-001', address: '上海市浦东新区张江路100号', status: '1', contact: '郑店长', phone: '18800110010', area: 600, createTime: '2025-06-25', flowId: 'WF002' },
  ],
  'WF004': [
    { storeId: 'S011', merchantId: 'M004', channelId: 'CH001', storeName: '京东母婴通州店', storeCode: 'JM-MB-001', address: '北京市通州区新华大街100号', status: '1', contact: '孙店长', phone: '18800110011', area: 280, createTime: '2025-06-30', flowId: 'WF004' },
    { storeId: 'S012', merchantId: 'M005', channelId: 'CH001', storeName: '京东家居大兴店', storeCode: 'JM-JJ-001', address: '北京市大兴区黄村东大街38号', status: '1', contact: '李店长', phone: '18800110012', area: 350, createTime: '2025-07-03', flowId: 'WF004' },
  ],
  'WF007': [
    { storeId: 'S013', merchantId: 'M012', channelId: 'CH006', storeName: '海底捞春熙路店', storeCode: 'HDL-2025-001', address: '成都市锦江区春熙路IFS', status: '1', contact: '王店长', phone: '18800110013', area: 800, createTime: '2025-07-20', flowId: 'WF007' },
    { storeId: 'S014', merchantId: 'M012', channelId: 'CH006', storeName: '海底捞天府广场店', storeCode: 'HDL-2025-002', address: '成都市青羊区天府广场', status: '1', contact: '李店长', phone: '18800110014', area: 650, createTime: '2025-07-22', flowId: 'WF007' },
  ],
  'WF008': [
    { storeId: 'S015', merchantId: 'M013', channelId: 'CH001', storeName: '京东退出门店A', storeCode: 'JM-EXIT-S001', address: '北京市测试地址', status: '0', contact: '测试', phone: '13800138001', area: 100, createTime: '2025-07-20', flowId: 'WF008' },
  ],
  'WF010': [
    { storeId: 'S016', merchantId: 'M014', channelId: 'CH003', storeName: '美团新增门店', storeCode: 'MT-NEW-S001', address: '深圳市南山区科技园', status: '1', contact: '测试', phone: '13800138002', area: 200, createTime: '2025-07-18', flowId: 'WF010' },
  ],
  'WF011': [
    { storeId: 'S017', merchantId: 'M015', channelId: 'CH004', storeName: '唯品会广州门店', storeCode: 'VP-GZ-001', address: '广州市天河区天河路', status: '1', contact: '刘店长', phone: '18800110015', area: 450, createTime: '2025-07-15', flowId: 'WF011' },
  ],
  'WF013': [
    { storeId: 'S018', merchantId: 'M016', channelId: 'CH002', storeName: '拼多多上海旗舰店', storeCode: 'PM-2025-002', address: '上海市浦东新区张江路100号', status: '1', contact: '郑店长', phone: '18800110016', area: 600, createTime: '2025-07-12', flowId: 'WF013' },
  ],
  'WF014': [
    { storeId: 'S019', merchantId: 'M017', channelId: 'CH002', storeName: '拼多多第二批门店', storeCode: 'PM-2025-003', address: '上海市闵行区七宝镇', status: '1', contact: '吴店长', phone: '18800110017', area: 380, createTime: '2025-07-30', flowId: 'WF014' },
  ],
}

export const mockAuditRecords = [
  { id: 'AR001', workflowId: 'WF001', auditType: '初审', auditor: '审核员A', auditTime: '2025-06-20 09:00', result: '通过', opinion: '材料齐全，初审通过。' },
  { id: 'AR002', workflowId: 'WF001', auditType: '终审', auditor: '审核员B', auditTime: '2025-07-01 14:00', result: '不通过', opinion: '部分商户资质材料不符合要求，请补充后重新提交。' },
  { id: 'AR003', workflowId: 'WF002', auditType: '初审', auditor: '审核员A', auditTime: '2025-06-25 11:00', result: '通过', opinion: '材料齐全，初审通过。' },
  { id: 'AR004', workflowId: 'WF004', auditType: '初审', auditor: '审核员A', auditTime: '2025-06-22 10:00', result: '通过', opinion: '商户资料完整，初审通过。' },
  { id: 'AR005', workflowId: 'WF004', auditType: '终审', auditor: '审核员B', auditTime: '2025-06-28 15:00', result: '通过', opinion: '终审通过。' },
  { id: 'AR006', workflowId: 'WF005', auditType: '初审', auditor: '审核员A', auditTime: '2025-07-08 10:00', result: '不通过', opinion: '材料不完整，缺少业务联系人身份证明文件。' },
  { id: 'AR007', workflowId: 'WF006', auditType: '初审', auditor: '审核员A', auditTime: '2025-07-12 09:00', result: '通过', opinion: '初审通过，材料完整。' },
  { id: 'AR008', workflowId: 'WF006', auditType: '终审', auditor: '审核员B', auditTime: '2025-07-15 16:00', result: '不通过', opinion: '企业销售额证明材料不符合要求，终审不通过。' },
  { id: 'AR009', workflowId: 'WF007', auditType: '初审', auditor: '审核员A', auditTime: '2025-07-16 09:00', result: '通过', opinion: '文件解析完毕，待初审。' },
  { id: 'AR010', workflowId: 'WF008', auditType: '初审', auditor: '审核员A', auditTime: '2025-07-21 10:00', result: '通过', opinion: '退出材料齐全，初审通过。' },
  { id: 'AR011', workflowId: 'WF010', auditType: '初审', auditor: '审核员A', auditTime: '2025-07-19 10:00', result: '通过', opinion: '文件识别处理完毕，待初审。' },
  { id: 'AR012', workflowId: 'WF011', auditType: '初审', auditor: '审核员A', auditTime: '2025-07-20 10:00', result: '通过', opinion: '补充材料齐全，初审通过。' },
  { id: 'AR013', workflowId: 'WF012', auditType: '初审', auditor: '审核员A', auditTime: '2025-07-08 10:00', result: '不通过', opinion: '资质证明材料不符合要求。' },
  { id: 'AR014', workflowId: 'WF012', auditType: '终审', auditor: '审核员B', auditTime: '2025-07-12 14:00', result: '不通过', opinion: '终审不通过，资质材料不合格。' },
  { id: 'AR015', workflowId: 'WF013', auditType: '初审', auditor: '审核员A', auditTime: '2025-07-15 10:00', result: '通过', opinion: '补充资质齐全，初审通过。' },
  { id: 'AR016', workflowId: 'WF013', auditType: '终审', auditor: '审核员B', auditTime: '2025-07-25 14:00', result: '通过', opinion: '终审通过，资质符合要求。' },
  { id: 'AR017', workflowId: 'WF014', auditType: '初审', auditor: '审核员A', auditTime: '2025-07-30 10:00', result: '通过', opinion: '第二批材料齐全，初审通过。' },
  { id: 'AR018', workflowId: 'WF015', auditType: '初审', auditor: '审核员A', auditTime: '2025-08-01 10:00', result: '通过', opinion: '补充材料齐全，初审通过。' },
  { id: 'AR019', workflowId: 'WF015', auditType: '终审', auditor: '审核员B', auditTime: '2025-08-05 15:00', result: '通过', opinion: '终审通过，资质符合要求。' },
]

export const mockWorkflowFiles = [
  { id: 'QF001', workflowId: 'WF001', fileName: '北京京东世纪贸易有限公司_渠道申报材料.zip', fileSize: '25.6MB', uploadTime: '2025-06-15 10:30', status: '已驳回', remark: '资质材料不符合要求' },
  { id: 'QF002', workflowId: 'WF001', fileName: '京东_商户材料汇总.xlsx', fileSize: '3.2MB', uploadTime: '2025-06-15 10:35', status: '已驳回', remark: '商户资质不完整' },
  { id: 'QF003', workflowId: 'WF002', fileName: '上海寻梦信息技术有限公司_渠道申报材料.zip', fileSize: '18.3MB', uploadTime: '2025-06-20 09:15', status: '已通过', remark: '' },
  { id: 'QF004', workflowId: 'WF003', fileName: '深圳美团科技有限公司_新增商户材料.zip', fileSize: '12.8MB', uploadTime: '2025-07-01 14:00', status: '解析中', remark: '' },
  { id: 'QF005', workflowId: 'WF004', fileName: '京东_新增商户材料V2.zip', fileSize: '8.5MB', uploadTime: '2025-06-20 10:00', status: '已通过', remark: '' },
  { id: 'QF006', workflowId: 'WF005', fileName: '唯品会_渠道申报材料.zip', fileSize: '15.2MB', uploadTime: '2025-07-05 16:30', status: '已驳回', remark: '材料不完整' },
  { id: 'QF007', workflowId: 'WF006', fileName: '网易严选_渠道申报材料.zip', fileSize: '22.1MB', uploadTime: '2025-07-10 10:00', status: '已通过', remark: '' },
  { id: 'QF008', workflowId: 'WF007', fileName: '海底捞_新增商户材料.zip', fileSize: '5.6MB', uploadTime: '2025-07-15 08:30', status: '解析完毕', remark: '' },
  { id: 'QF009', workflowId: 'WF008', fileName: '京东_退出商户材料.zip', fileSize: '2.1MB', uploadTime: '2025-07-20 11:00', status: '待审核', remark: '' },
  { id: 'QF010', workflowId: 'WF009', fileName: '拼多多_修改商户材料.zip', fileSize: '4.3MB', uploadTime: '2025-07-22 14:30', status: '暂存', remark: '' },
  { id: 'QF011', workflowId: 'WF010', fileName: '美团_新增门店材料.zip', fileSize: '9.8MB', uploadTime: '2025-07-18 09:00', status: '识别完毕', remark: '' },
  { id: 'QF012', workflowId: 'WF011', fileName: '唯品会_渠道申报材料_补充.zip', fileSize: '18.5MB', uploadTime: '2025-07-12 09:00', status: '已通过', remark: '' },
  { id: 'QF013', workflowId: 'WF012', fileName: '拼多多_渠道申报材料.zip', fileSize: '20.1MB', uploadTime: '2025-07-01 09:00', status: '已驳回', remark: '资质材料不合格' },
  { id: 'QF014', workflowId: 'WF013', fileName: '拼多多_渠道申报材料_补充版.zip', fileSize: '22.3MB', uploadTime: '2025-07-10 09:00', status: '已通过', remark: '' },
  { id: 'QF015', workflowId: 'WF014', fileName: '拼多多_第二批申报材料.zip', fileSize: '14.2MB', uploadTime: '2025-07-28 10:00', status: '待审核', remark: '' },
  { id: 'QF016', workflowId: 'WF015', fileName: '京东_渠道申报材料_补充.zip', fileSize: '19.8MB', uploadTime: '2025-07-28 09:00', status: '已通过', remark: '' },
]

export function getWorkflowsByChannel(channelId) {
  return mockWorkflows.filter(w => w.channelId === channelId)
}
